// extracted by mini-css-extract-plugin
export default {"btn":"MarketGraphButton_btn__eMqmY","btn__icon":"MarketGraphButton_btn__icon__u7qQF","link":"MarketGraphButton_link__DdfyD","link__icon":"MarketGraphButton_link__icon__-KY1Y"};